module.exports = __webpack_public_path__ + "media/images/state-place-holder-2b45c7a43e5ef21859d61d004d4120c3.png";